"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignatures = void 0;
const fs_1 = require("fs");
const hash_1 = require("./hash");
const pMap = require("p-map");
const { readFile } = fs_1.promises;
async function getSignatures(paths) {
    return pMap(paths, async (path) => {
        const content = await readFile(path);
        return content.length > 0 ? await hash_1.getHashSignature(path, content) : null;
    }, { concurrency: 20 });
}
exports.getSignatures = getSignatures;
//# sourceMappingURL=signatures.js.map